import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '@examdojo/core/button';
import { TranslocoPipe } from '@jsverse/transloco';
import { RiveDirective } from '../rive';

@Component({
  selector: 'dojo-not-found-page',
  template: `
    <!--
      The 404 artboard leaves ~42px of transparent canvas below the mascot's shadow.
      The negative bottom margin cancels it, so the host's gap-8 is measured from the
      artwork rather than the canvas box and no dead space is left between the mascot
      and the title.
    -->
    <canvas
      rive
      loading="lazy"
      class="-mb-[42px] h-[320px] w-[320px]"
      [riveFile]="'assets/images/404.riv'"
      [artboard]="'404'"
      [stateMachine]="'404'"
      [autoplay]="true"
      width="500"
      height="500"
    ></canvas>

    <div class="flex flex-col items-center gap-2 text-center">
      <h1 class="text-display-md text-primary font-semibold">
        {{ 'examdojo.not_found_page.title' | transloco }}
      </h1>
      <p class="text-secondary text-md">{{ 'examdojo.not_found_page.subtitle' | transloco }}</p>
    </div>

    <dojo-button [routerLink]="['/']" class="w-[178px]">
      {{ 'examdojo.not_found_page.return_home' | transloco }}
    </dojo-button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'bg-neutral-0 flex h-full flex-col items-center justify-center gap-8 p-6' },
  imports: [ButtonComponent, RiveDirective, RouterLink, TranslocoPipe],
})
export class NotFoundPageComponent {}
